(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ils-ont-choisi-iron-meals"] && !Shopify.designMode) return;
  try {
    
  function imChampionsInit(root) {
    if (!root || root.dataset.imReady === 'true') return;

    const carousel = root.querySelector('[data-im-carousel]');
    const items = root.querySelectorAll('.im-champions__item');
    const nextBtn = root.querySelector('[data-im-next]');
    const prevBtn = root.querySelector('[data-im-prev]');

    if (!carousel || items.length === 0) return;

    root.dataset.imReady = 'true';

    const gap = parseInt(root.dataset.gap || '15', 10);
    const autoplay = root.dataset.autoplay === 'true';
    const interval = parseInt(root.dataset.interval || '5000', 10);
    let currentIndex = 0;

    function cardWidth() {
      return items[0].offsetWidth + gap;
    }

    function goTo(index) {
      const max = items.length - 1;
      currentIndex = Math.max(0, Math.min(index, max));
      carousel.scrollTo({ left: currentIndex * cardWidth(), behavior: 'smooth' });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        if (currentIndex < items.length - 1) goTo(currentIndex + 1);
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        if (currentIndex > 0) goTo(currentIndex - 1);
      });
    }

    carousel.addEventListener('scroll', function () {
      currentIndex = Math.round(carousel.scrollLeft / cardWidth());
    });

    function startAutoplay() {
      if (!autoplay || items.length < 2 || root._imTimer) return;
      root._imTimer = setInterval(function () {
        if (!root.isConnected) {
          clearInterval(root._imTimer);
          root._imTimer = null;
          return;
        }
        goTo(currentIndex < items.length - 1 ? currentIndex + 1 : 0);
      }, interval);
    }

    function stopAutoplay() {
      if (root._imTimer) {
        clearInterval(root._imTimer);
        root._imTimer = null;
      }
    }

    startAutoplay();

    const modal = root.querySelector('[data-im-modal]');
    const modalImage = root.querySelector('[data-im-modal-image]');
    const triggers = root.querySelectorAll('[data-im-open]');
    const modalPrev = root.querySelector('[data-im-modal-prev]');
    const modalNext = root.querySelector('[data-im-modal-next]');
    const closeBtn = root.querySelector('[data-im-modal-close]');
    let galleryIndex = 0;
    let touchX = 0;
    let wheelLock = false;

    function showGalleryImage(index) {
      const trigger = triggers[index];
      if (!trigger || !modalImage) return;
      galleryIndex = index;
      modalImage.src = trigger.dataset.imSrc;
      modalImage.alt = trigger.dataset.imAlt || '';
    }

    function stepGallery(delta) {
      if (!triggers.length) return;
      showGalleryImage((galleryIndex + delta + triggers.length) % triggers.length);
    }

    function onModalKey(event) {
      if (event.key === 'ArrowRight') stepGallery(1);
      if (event.key === 'ArrowLeft') stepGallery(-1);
    }

    function closeModal() {
      if (!modal || !modal.open || modal.classList.contains('is-closing')) return;
      modal.classList.remove('is-visible');
      modal.classList.add('is-closing');
      modal.removeEventListener('keydown', onModalKey);
      setTimeout(function () {
        if (modal.open) modal.close();
        modal.classList.remove('is-closing');
        if (modalImage) modalImage.removeAttribute('src');
        startAutoplay();
      }, 160);
    }

    function openModal(index) {
      if (!modal || !modalImage || !triggers[index]) return;
      showGalleryImage(index);
      stopAutoplay();
      if (typeof modal.showModal === 'function') {
        modal.showModal();
      } else {
        modal.setAttribute('open', '');
      }
      modal.addEventListener('keydown', onModalKey);
      requestAnimationFrame(function () {
        modal.classList.add('is-visible');
      });
    }

    triggers.forEach(function (trigger, index) {
      trigger.addEventListener('click', function () {
        openModal(index);
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (modalPrev) modalPrev.addEventListener('click', function () { stepGallery(-1); });
    if (modalNext) modalNext.addEventListener('click', function () { stepGallery(1); });

    if (modal) {
      modal.addEventListener('click', function (event) {
        if (event.target === modal) closeModal();
      });
      modal.addEventListener('close', function () {
        modal.classList.remove('is-visible', 'is-closing');
        if (modalImage) modalImage.removeAttribute('src');
        startAutoplay();
      });
      modal.addEventListener('touchstart', function (event) {
        touchX = event.touches[0].clientX;
      }, { passive: true });
      modal.addEventListener('touchmove', function (event) {
        event.preventDefault();
      }, { passive: false });
      modal.addEventListener('touchend', function (event) {
        const dx = event.changedTouches[0].clientX - touchX;
        if (Math.abs(dx) > 40) stepGallery(dx < 0 ? 1 : -1);
      }, { passive: true });
      modal.addEventListener('wheel', function (event) {
        if (wheelLock || !modal.open) return;
        if (Math.abs(event.deltaX) < 10 && Math.abs(event.deltaY) < 10) return;
        wheelLock = true;
        const dir = Math.abs(event.deltaX) > Math.abs(event.deltaY) ? event.deltaX : event.deltaY;
        stepGallery(dir > 0 ? 1 : -1);
        setTimeout(function () { wheelLock = false; }, 280);
      }, { passive: true });
    }
  }

  function imChampionsDestroy(root) {
    if (!root) return;
    if (root._imTimer) {
      clearInterval(root._imTimer);
      root._imTimer = null;
    }
    const modal = root.querySelector('[data-im-modal]');
    if (modal && modal.open) modal.close();
    root.dataset.imReady = '';
  }

  document.querySelectorAll('[data-im-champions]').forEach(imChampionsInit);

  document.addEventListener('shopify:section:load', function (event) {
    imChampionsInit(event.target.querySelector('[data-im-champions]'));
  });

  document.addEventListener('shopify:section:unload', function (event) {
    imChampionsDestroy(event.target.querySelector('[data-im-champions]'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["suivi-commande"] && !Shopify.designMode) return;
  try {
    
(function () {
  var STATUS_LABELS = {
    PAID: 'Payée', PARTIALLY_PAID: 'Partiellement payée', AUTHORIZED: 'Autorisée',
    PENDING: 'En attente', REFUNDED: 'Remboursée', VOIDED: 'Annulée',
    PARTIALLY_REFUNDED: 'Remboursée en partie',
    FULFILLED: 'Expédiée', UNFULFILLED: 'En préparation',
    PARTIALLY_FULFILLED: 'Partiellement expédiée', IN_PROGRESS: 'En préparation',
    SCHEDULED: 'Programmée', ON_HOLD: 'En attente'
  };

  function paymentChip(financialStatus) {
    var fin = (financialStatus || '').toUpperCase();
    var label = STATUS_LABELS[fin] || financialStatus || '—';
    var tone = 'pending';
    if (fin === 'PAID' || fin === 'PARTIALLY_PAID' || fin === 'AUTHORIZED') tone = 'paid';
    else if (fin === 'REFUNDED' || fin === 'VOIDED' || fin === 'PARTIALLY_REFUNDED') tone = 'refunded';
    return { label: label, tone: tone };
  }

  function orderHasTracking(order) {
    return (order.fulfillments || []).some(function (f) {
      return f && (f.trackingNumber || f.trackingUrl);
    });
  }

  var EASYROUTES_ZIP_PREFIXES = ['75', '78', '92', '93', '94', '95'];

  function carrierFromZip(zip) {
    var clean = String(zip || '').replace(/\D/g, '');
    if (clean.length < 2) return null;
    var prefix = clean.slice(0, 2);
    return EASYROUTES_ZIP_PREFIXES.indexOf(prefix) >= 0 ? 'easyroutes' : 'chronofresh';
  }

  function getOrderCarrier(o) {
    if (o && (o.carrier === 'easyroutes' || o.carrier === 'chronofresh')) return o.carrier;
    if (o && o.shippingZip) return carrierFromZip(o.shippingZip);
    return null;
  }

  function isEasyRoutesOrder(o) {
    return getOrderCarrier(o) === 'easyroutes';
  }

  var AT_SHIPPER_RE = /pr[eé]paration[^.]{0,60}exp[eé]diteur|chez l['']?\s*exp[eé]diteur|en pr[eé]paration chez/i;
  var PICKUP_DONE_RE = /pick(?:ed)?[_\s-]?up|carrier[_\s-]?pick|prise en charge|enlev[eé]|remis au transporteur/i;

  function fulfillmentHasPickupDone(f) {
    var ds = String((f && (f.displayStatus || f.status)) || '').toUpperCase();
    if (ds === 'PICKED_UP' || ds === 'CARRIER_PICKED_UP') return true;
    var blob = ds;
    (f.events || []).forEach(function (ev) {
      blob += ' ' + (ev.status || '') + ' ' + (ev.message || '');
    });
    return PICKUP_DONE_RE.test(blob);
  }

  function isAwaitingChronoFresh(order) {
    var sub = String(order.subStatus || '').toUpperCase();
    if (sub === 'AWAITING_PICKUP') return true;
    if (sub === 'OUT_FOR_DELIVERY' || sub === 'DELIVERED' || sub === 'ATTEMPTED_DELIVERY') return false;
    if (!orderHasTracking(order)) return false;
    var fuls = order.fulfillments || [];
    if (fuls.some(fulfillmentHasPickupDone)) return false;
    var i;
    for (i = 0; i < fuls.length; i++) {
      var f = fuls[i];
      var blob = String((f.displayStatus || f.status) || '');
      (f.events || []).forEach(function (ev) {
        blob += ' ' + (ev.status || '') + ' ' + (ev.message || '');
      });
      if (AT_SHIPPER_RE.test(blob)) return true;
      var ds = blob.toUpperCase();
      if (ds.indexOf('CONFIRMED') >= 0 || ds.indexOf('SUBMITTED') >= 0) return true;
    }
    if (sub === 'CONFIRMED' || sub === 'SUBMITTED') return true;
    var done = Number(order.step) || 1;
    return done < 3;
  }

  /**
   * order.step = dernière étape TERMINÉE (1–5). Étape affichée = step + 1 (max 5 si livré).
   */
  function buildOrderStepsEasyRoutes(order) {
    var er = order.easyroutes || {};
    var erStatus = er.status ? er.status.toUpperCase() : 'UNKNOWN';
    var etaIsEstimated = !!er.etaEstimated;
    var eta = er.etaEstimated || er.etaPlanned || er.eta || null;
    var etaWord = etaIsEstimated ? 'estimé' : 'prévu';
    var sub = String(order.subStatus || '').toUpperCase();
    var delivered     = erStatus === 'DELIVERED'          || sub === 'DELIVERED';
    var outForDel     = erStatus === 'OUT_FOR_DELIVERY'   || sub === 'OUT_FOR_DELIVERY';
    var attempted     = erStatus === 'ATTEMPTED_DELIVERY' || sub === 'ATTEMPTED_DELIVERY';
    var readyForDel   = erStatus === 'READY_FOR_DELIVERY';
    var pastPrep      = readyForDel || outForDel || attempted || delivered;

    // done = nombre d’étapes terminées (sur 5)
    var done, currentNum;
    if (delivered) {
      done = 5; currentNum = 5;
    } else if (outForDel || attempted) {
      done = 3; currentNum = 4;
    } else if (readyForDel) {
      done = 2; currentNum = 3;
    } else {
      done = 1; currentNum = 2;
    }

    var step2Label = pastPrep ? 'Commande préparée' : 'En préparation';
    var step2Desc  = pastPrep
      ? 'Vos plats ont été préparés par nos chefs.'
      : 'Vos plats sont en cours de préparation par nos chefs.';

    var step4Label = attempted
      ? 'Expédié · Tentative de livraison'
      : 'Expédié · En cours de livraison';
    var step4Desc  = attempted
      ? 'Votre livreur a tenté de vous livrer. Contactez-nous.'
      : 'Votre livreur est en route vers votre adresse.';

    var etaWin = fmtEtaWindow(eta);
    var etaShort = etaWin ? etaWin.range : '';
    var chosenDate = chosenDeliveryDateText(order);
    var steps = [
      { short: 'Commandé',    label: 'Commandé',   desc: 'Paiement confirmé.', date: '', hint: '' },
      { short: 'Préparation', label: step2Label, desc: step2Desc, date: '', hint: chosenDate && done <= 2 && !readyForDel ? 'Livraison prévue : ' + chosenDate : '' },
      { short: 'Expédition',  label: 'Commande préparée, sera bientôt expédiée',
        desc: '',
        date: '', hint: etaShort && readyForDel ? 'Créneau ' + etaWord + ' : ' + etaShort : '' },
      { short: 'En livraison', label: step4Label, desc: step4Desc,
        date: '', hint: etaShort && outForDel ? 'Créneau ' + etaWord + ' : ' + etaShort : '' },
      { short: 'Livré', label: 'Livré', desc: 'Bon appétit !', date: '', hint: '' }
    ];
    return {
      steps: steps,
      done: done,
      currentNum: currentNum,
      curIdx: currentNum - 1,
      awaiting: false,
      delivered: delivered
    };
  }

  function buildOrderSteps(order) {
    if (isEasyRoutesOrder(order)) return buildOrderStepsEasyRoutes(order);
    var done = Math.min(Math.max(Number(order.step) || 1, 1), 5);
    var sub = String(order.subStatus || '').toUpperCase();
    var td = order.timelineDates || {};
    var awaiting = isAwaitingChronoFresh(order);
    if (awaiting && done < 2) done = 2;
    var outDel = sub === 'OUT_FOR_DELIVERY';
    var delivered = done >= 5 || sub === 'DELIVERED';
    var currentNum = delivered ? 5 : (awaiting ? 3 : Math.min(done + 1, 5));
    var curIdx = currentNum - 1;
    var awaitingMsg = "Commande préparée, en attente d'enlèvement par ChronoFresh.";
    var chosenDate = chosenDeliveryDateText(order);
    var step2 = done >= 2
      ? { short: 'Préparée', label: 'Préparée', desc: 'Vos plats sont prêts chez IRON MEALS.', date: '', hint: chosenDate && done < 3 ? 'Livraison prévue : ' + chosenDate : '' }
      : {
          short: 'Préparation',
          label: 'En préparation',
          desc: 'Vos plats sont en cours de préparation par nos chefs.',
          date: '',
          hint: chosenDate ? 'Livraison prévue : ' + chosenDate : ''
        };
    var step3 = awaiting
      ? {
          short: 'ChronoFresh',
          label: 'En attente d’enlèvement ChronoFresh',
          desc: awaitingMsg,
          date: '',
          hint: td.pickupEstimateAt ? 'Enlèvement estimé le ' + fmtDate(td.pickupEstimateAt) : ''
        }
      : {
          short: 'Expédié',
          label: 'Expédié',
          desc: 'Pris en charge par ChronoFresh.',
          date: done >= 3 && td.readyAt ? fmtDate(td.readyAt) : '',
          hint: ''
        };
    var step4 = outDel
      ? { short: 'Livraison', label: 'En cours de livraison', desc: 'Votre colis arrive bientôt chez vous.', date: '', hint: '' }
      : { short: 'Transit', label: 'En cours d’acheminement', desc: 'Votre colis est en route vers votre adresse.', date: '', hint: '' };
    var steps = [
      { short: 'Commandé', label: 'Commandé', desc: 'Paiement confirmé.', date: fmtDate(td.orderedAt || order.createdAt), hint: '' },
      step2,
      step3,
      step4,
      {
        short: 'Livré',
        label: 'Livré',
        desc: 'Bon appétit !',
        date: order.deliveryDate || fmtDate(td.deliveryAt) || '',
        hint: order.deliveryDate ? 'Jour choisi à la commande' : ''
      }
    ];
    return {
      steps: steps,
      done: done,
      currentNum: currentNum,
      curIdx: curIdx,
      awaiting: awaiting,
      delivered: delivered
    };
  }

  var EVENT_LABELS = {
    LABEL_PURCHASED: 'Étiquette d’expédition créée',
    LABEL_PRINTED: 'Étiquette imprimée',
    READY_FOR_PICKUP: 'Disponible en point relais',
    CONFIRMED: 'Enregistrée chez ChronoFresh',
    SUBMITTED: 'En attente d’enlèvement par ChronoFresh',
    IN_TRANSIT: 'En transit',
    OUT_FOR_DELIVERY: 'En cours de livraison',
    ATTEMPTED_DELIVERY: 'Tentative de livraison',
    DELIVERED: 'Livré',
    MARKED_AS_DELIVERED: 'Marqué comme livré',
    FAILURE: 'Incident de livraison',
    NOT_DELIVERED: 'Non livré',
    PICKED_UP: 'Colis remis au transporteur'
  };

  function fmtMoney(amount, currency) {
    if (amount == null) return '';
    try {
      return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: currency || 'EUR' })
        .format(parseFloat(amount));
    } catch (_) { return amount + ' ' + (currency || ''); }
  }

  // Parse robuste (iOS Safari est strict : refuse "YYYY-MM-DD HH:MM" sans T, etc.).
  function imParseDate(value) {
    if (!value) return null;
    if (value instanceof Date) return isNaN(value.getTime()) ? null : value;
    var s = String(value).trim();
    if (!s) return null;
    var d = new Date(s);
    if (!isNaN(d.getTime())) return d;
    // Fallback Safari : remplace l'espace par T (et coupe les microsecondes).
    d = new Date(s.replace(' ', 'T').replace(/\.\d+/, ''));
    if (!isNaN(d.getTime())) return d;
    // Dernier recours : extraction manuelle des composants.
    var m = s.match(/(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::(\d{2}))?/);
    if (m) {
      var off = s.match(/([+-]\d{2}):?(\d{2})$/);
      if (/[zZ]$/.test(s) || off) {
        // Avec fuseau → reconstruit en ISO strict que tous les navigateurs acceptent.
        var iso = m[1] + '-' + m[2] + '-' + m[3] + 'T' + m[4] + ':' + m[5] + ':' + (m[6] || '00') +
          (/[zZ]$/.test(s) ? 'Z' : (off[1] + ':' + off[2]));
        d = new Date(iso);
        if (!isNaN(d.getTime())) return d;
      }
      return new Date(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +(m[6] || 0));
    }
    return null;
  }

  function fmtDate(iso) {
    var d = imParseDate(iso);
    if (!d) return iso ? String(iso) : '';
    return d.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
  }

  function fmtDateTime(iso) {
    var d = imParseDate(iso);
    if (!d) return iso ? String(iso) : '';
    return d.toLocaleString('fr-FR', {
      day: '2-digit', month: '2-digit', year: 'numeric',
      hour: '2-digit', minute: '2-digit'
    });
  }

  // ETA EasyRoutes : timestamp ISO → "aujourd'hui à 14:30" / "mer. 17/06 à 14:30".
  function fmtEta(value) {
    var d = imParseDate(value);
    if (!d) return typeof value === 'string' ? value : '';
    var now = new Date();
    var sameDay = d.getFullYear() === now.getFullYear() &&
      d.getMonth() === now.getMonth() && d.getDate() === now.getDate();
    var time = d.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
    if (sameDay) return "aujourd'hui à " + time;
    var day = d.toLocaleDateString('fr-FR', {
      weekday: 'short', day: '2-digit', month: '2-digit'
    });
    return day + ' à ' + time;
  }

  // Créneau de 2 h calé sur l'ETA EasyRoutes : l'ETA = début de la plage
  // (arrondi au quart d'heure, comme EasyRoutes), fin = début + 2 h.
  // Renvoie { day, range } ex. { day: "aujourd'hui", range: "14:15 – 16:15" }.
  function fmtEtaWindow(value) {
    var d = imParseDate(value);
    if (!d) return null;
    var start = new Date(d.getTime());
    var rem = start.getMinutes() % 15;
    if (rem) start.setMinutes(start.getMinutes() - rem); // arrondi au quart d'heure inférieur
    start.setSeconds(0, 0);
    var end = new Date(start.getTime() + 120 * 60 * 1000); // +2 h
    var hhmm = function (x) {
      return x.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
    };
    var now = new Date();
    var sameDay = d.getFullYear() === now.getFullYear() &&
      d.getMonth() === now.getMonth() && d.getDate() === now.getDate();
    var day = sameDay
      ? "aujourd'hui"
      : d.toLocaleDateString('fr-FR', { weekday: 'long', day: '2-digit', month: '2-digit' });
    return { day: day, range: hhmm(start) + ' – ' + hhmm(end) };
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function timeline(order) {
    var data = buildOrderSteps(order);
    return '<ol class="im-timeline' + (data.awaiting ? ' im-timeline--awaiting' : '') + '" data-step="' + data.done + '" data-current="' + data.currentNum + '">' +
      data.steps.map(function (s, i) {
        var n = i + 1;
        var cls = 'im-timeline__step';
        if (data.delivered ? n <= 5 : n <= data.done) cls += ' is-done';
        else if (!data.delivered && n === data.currentNum) cls += ' is-current';
        var dateHtml = s.date
          ? '<span class="im-timeline__date">' + escapeHtml(s.date) + '</span>'
          : '';
        var hintHtml = s.hint
          ? '<span class="im-timeline__hint">' + escapeHtml(s.hint) + '</span>'
          : '';
        return '<li class="' + cls + '">' +
          '<span class="im-timeline__dot" aria-hidden="true"></span>' +
          '<div class="im-timeline__body">' +
          '<span class="im-timeline__label">' + escapeHtml(s.label) + '</span>' +
          '<span class="im-timeline__desc">' + escapeHtml(s.desc) + '</span>' +
          dateHtml + hintHtml +
          '</div></li>';
      }).join('') + '</ol>';
  }

  function deliveryInfoCardsHtml(phone, carrier) {
    var joinable = phone
      ? 'Le livreur vous appelle au <strong>' + escapeHtml(phone) + '</strong> le jour J.'
      : 'Restez joignable le jour de livraison.';
    if (carrier === 'easyroutes') {
      return '<p class="im-delivery-info__intro">Rappels livraison</p>' +
        '<div class="im-delivery-info__cards">' +
          '<div class="im-delivery-info__card"><span class="im-delivery-info__card-title">Au frais</span>' +
          '<p>Réfrigérez vos repas dès réception (4°C).</p></div>' +
          '<div class="im-delivery-info__card"><span class="im-delivery-info__card-title">Joignable</span>' +
          '<p>' + joinable + '</p></div>' +
          '<div class="im-delivery-info__card"><span class="im-delivery-info__card-title">En main propre</span>' +
          '<p>Votre livreur remet la commande directement en main propre.</p></div>' +
          '<div class="im-delivery-info__card"><span class="im-delivery-info__card-title">Modification</span>' +
          '<p>Changement de jour possible jusqu’à 48 h avant l’expédition.</p></div>' +
        '</div>';
    }
    return '<p class="im-delivery-info__intro">Rappels livraison</p>' +
      '<div class="im-delivery-info__cards">' +
        '<div class="im-delivery-info__card"><span class="im-delivery-info__card-title">Au frais</span>' +
        '<p>Réfrigérez vos repas dès réception (4°C).</p></div>' +
        '<div class="im-delivery-info__card"><span class="im-delivery-info__card-title">Créneau</span>' +
        '<p>La veille, ChronoFresh vous envoie un créneau d’1 h — soyez présent.</p></div>' +
        '<div class="im-delivery-info__card"><span class="im-delivery-info__card-title">Joignable</span>' +
        '<p>' + joinable + '</p></div>' +
        '<div class="im-delivery-info__card"><span class="im-delivery-info__card-title">Modification</span>' +
        '<p>Changement de jour possible jusqu’à 48 h avant l’expédition.</p></div>' +
        '<div class="im-delivery-info__card"><span class="im-delivery-info__card-title">Absence</span>' +
        '<p>Sur votre suivi ChronoFresh : reprogrammez la livraison, modifiez l’adresse ou choisissez un point relais frais (selon conditions ChronoFresh).</p></div>' +
      '</div>';
  }

  function chosenDeliveryDateText(o) {
    return o.deliveryDate || o.deliveryDateRaw || '';
  }

  function renderChosenDeliveryDateHero(o) {
    var dateText = chosenDeliveryDateText(o);
    if (!dateText) return '';
    return '<div class="im-delivery-info__hero im-suivi__delivery-hero">' +
      '<span class="im-delivery-info__badge">Jour de livraison</span>' +
      '<span class="im-delivery-info__date-badge">' + escapeHtml(dateText) + '</span>' +
      '</div>';
  }

  function renderDeliveryInfo(o, hasTracking) {
    var dateText = chosenDeliveryDateText(o);
    var heroHtml = dateText
      ? '<div class="im-delivery-info__hero">' +
        '<span class="im-delivery-info__badge">Jour de livraison</span>' +
        '<span class="im-delivery-info__date-badge">' + escapeHtml(dateText) + '</span>' +
        '</div>'
      : '<span class="im-delivery-info__badge">Rappel livraison</span>';
    var phone = o.contactPhoneDisplay || o.contactPhone;
    var step = o.step || 1;
    var awaiting = o.subStatus === 'AWAITING_PICKUP';
    var carrier = getOrderCarrier(o);
    var preparingMsg = carrier === 'easyroutes'
      ? 'Dès le départ de votre livreur, le suivi apparaîtra ici.'
      : 'Dès l’expédition, vous recevrez un e-mail avec votre numéro de suivi.';
    var preparing = !hasTracking && !awaiting && step < 3
      ? '<div class="im-preparing">' +
        '<p class="im-preparing__title">En préparation</p>' +
        '<p>' + preparingMsg + '</p>' +
        '</div>'
      : '';
    return '<div class="im-delivery-info">' +
      heroHtml + deliveryInfoCardsHtml(phone, carrier) + preparing +
    '</div>';
  }

  function renderTrackingBlock(o) {
    if (isEasyRoutesOrder(o)) return renderTrackingBlockEasyRoutes(o);
    var ful = (o.fulfillments || [])[0];
    var trackingUrl = ful && (ful.trackingUrl || (ful.trackingNumber
      ? 'https://www.chronopost.fr/tracking-no-cms/suivi-page?listeNumerosLT=' + encodeURIComponent(ful.trackingNumber) + '&langue=fr'
      : null));
    var hasTracking = !!trackingUrl;
    var hintHtml = hasTracking ? '' : '<p class="im-suivi__tracking-hint">Le suivi ChronoFresh apparaître ici dès l’expédition.</p>';
    var trackingHtml = '';
    if (trackingUrl) {
      trackingHtml = '<a class="im-btn im-btn--primary im-btn--tracking" target="_blank" rel="noopener" href="' +
        escapeHtml(trackingUrl) + '">' +
        '<span class="im-btn__label">Suivre sur le site ChronoFresh</span>' +
        (ful.trackingNumber ? '<span class="im-btn__sub">' + escapeHtml(ful.trackingNumber) + '</span>' : '') +
        '</a>';
    }
    return hintHtml + timeline(o) +
      (trackingHtml ? '<div class="im-suivi__order-actions im-suivi__order-actions--tracking">' + trackingHtml + '</div>' : '');
  }

  function renderTrackingBlockEasyRoutes(o) {
    var er = o.easyroutes || {};
    var erStatus = (er.status || 'UNKNOWN').toUpperCase();
    var proofPhotos = er.proofPhotos || [];
    var proofSigs = er.proofSignatures || [];
    var hintHtml = erStatus === 'UNKNOWN' || !o.fulfillments || !o.fulfillments[0]
      ? '<p class="im-suivi__tracking-hint">La livraison sera mise à jour ici dès le départ de votre livreur.</p>'
      : '';

    var etaHtml = '';
    var etaIsEstimated = !!er.etaEstimated;
    var etaVal = er.etaEstimated || er.etaPlanned || er.eta || null;
    var win = fmtEtaWindow(etaVal);
    if (win && erStatus !== 'DELIVERED') {
      var etaLabel = erStatus === 'OUT_FOR_DELIVERY'
        ? 'Votre livreur arrive'
        : (etaIsEstimated ? 'Créneau de livraison estimé' : 'Créneau de livraison prévu');
      etaHtml = '<div class="im-eta">' +
        '<span class="im-eta__icon" aria-hidden="true">🕑</span>' +
        '<span class="im-eta__body">' +
          '<span class="im-eta__label">' + escapeHtml(etaLabel) + '</span>' +
          '<span class="im-eta__range">' + escapeHtml(win.range) + '</span>' +
          '<span class="im-eta__day">' + escapeHtml(win.day) + '</span>' +
        '</span>' +
        '</div>';
    }

    var proofHtml = '';
    if ((proofPhotos.length || proofSigs.length) && erStatus === 'DELIVERED') {
      var imgs = proofPhotos.concat(proofSigs).map(function(url) {
        return '<a href="' + escapeHtml(url) + '" target="_blank" rel="noopener">' +
               '<img src="' + escapeHtml(url) + '" alt="Preuve de livraison" style="max-width:120px;border-radius:8px;" loading="lazy">' +
               '</a>';
      }).join('');
      proofHtml = '<div class="im-suivi__proof" style="margin-top:12px;display:flex;gap:8px;flex-wrap:wrap;">' + imgs + '</div>';
    }
    return hintHtml + etaHtml + timeline(o) + proofHtml;
  }

  function renderOrder(o) {
    var ful = (o.fulfillments || [])[0];
    var trackingUrl = ful && (ful.trackingUrl || (ful.trackingNumber
      ? 'https://www.chronopost.fr/tracking-no-cms/suivi-page?listeNumerosLT=' + encodeURIComponent(ful.trackingNumber) + '&langue=fr'
      : null));
    var hasTracking = !!trackingUrl;
    var pay = paymentChip(o.financialStatus);
    var eventsHtml = '';
    if (ful && ful.events && ful.events.length) {
      var items = ful.events.map(function (ev) {
        var label = EVENT_LABELS[(ev.status || '').toUpperCase()] || ev.status || '';
        return '<li class="im-events__item">' +
          '<time class="im-events__time">' + escapeHtml(fmtDateTime(ev.happenedAt)) + '</time>' +
          '<span class="im-events__label">' + escapeHtml(label) + '</span>' +
          (ev.message ? '<span class="im-events__msg">' + escapeHtml(ev.message) + '</span>' : '') +
        '</li>';
      }).join('');
      eventsHtml = '<details class="im-events"><summary>Historique de livraison (' + ful.events.length + ')</summary>' +
        '<ol class="im-events__list">' + items + '</ol></details>';
    }

    return '<div class="im-suivi__result-card">' +
      '<div class="im-suivi__order-head">' +
        '<div>' +
          '<span class="im-suivi__order-name">Commande ' + escapeHtml(o.name) + '</span>' +
          '<span class="im-suivi__order-date">' + escapeHtml(fmtDate(o.createdAt)) + '</span>' +
        '</div>' +
      '</div>' +
      '<div class="im-suivi__order-meta">' +
        '<span class="im-suivi__chip im-suivi__chip--' + escapeHtml(pay.tone) + '">Paiement : ' + escapeHtml(pay.label) + '</span>' +
      '</div>' +
      renderChosenDeliveryDateHero(o) +
      renderTrackingBlock(o) +
      '<div class="im-suivi__order-actions im-suivi__order-actions--reminders">' +
        '<button type="button" class="im-btn im-btn--ghost" data-im-open-reminders>Rappels livraison</button>' +
      '</div>' +
      eventsHtml +
    '</div>';
  }

  function renderError(code) {
    var msg;
    switch (code) {
      case 'not_found':
        msg = 'Aucune commande ne correspond. Vérifiez le téléphone (ou le n° de commande) et l’e-mail utilisés lors de l’achat.';
        break;
      case 'invalid_phone':
        msg = 'Numéro de téléphone invalide (au moins 9 chiffres).';
        break;
      case 'missing_params':
      case 'invalid_email':
        msg = 'Merci de renseigner un numéro de commande et un e-mail valides.';
        break;
      case 'invalid_signature':
        msg = 'Erreur d’authentification. Rechargez la page et réessayez.';
        break;
      case 'proxy_not_configured':
        msg = 'Le suivi n’est pas encore connecté à la boutique (App Proxy). Contactez le support IRON MEALS.';
        break;
      case 'shopify_token_failed':
      case 'invalid_client':
        msg = 'Connexion Shopify temporairement indisponible. Réessayez dans quelques minutes.';
        break;
      case 'shop_not_permitted':
        msg = 'Le suivi n’est pas encore autorisé sur cette boutique. Contactez le support IRON MEALS.';
        break;
      case 'misconfigured_secret':
        msg = 'Service de suivi en maintenance. Réessayez plus tard ou contactez-nous.';
        break;
      case 'internal_error':
        msg = 'Erreur technique temporaire. Réessayez dans quelques instants.';
        break;
      case 'network':
        msg = 'Impossible de joindre le serveur de suivi. Vérifiez votre connexion et réessayez.';
        break;
      default:
        msg = 'Une erreur est survenue. Réessayez dans quelques instants ou contactez-nous.';
    }
    return '<div class="im-suivi__result-error">' + escapeHtml(msg) + '</div>';
  }

  document.querySelectorAll('[data-im-toggle-orders]').forEach(function (btn) {
    var panel = btn.getAttribute('aria-controls')
      ? document.getElementById(btn.getAttribute('aria-controls'))
      : btn.parentElement && btn.parentElement.querySelector('[data-im-orders-more]');
    if (!panel) return;
    btn.addEventListener('click', function () {
      var open = panel.hidden;
      panel.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? 'Masquer mes autres commandes' : 'Afficher toutes mes commandes';
    });
  });

  function parseLookupResponse(r) {
    return r.text().then(function (text) {
      var trimmed = (text || '').trim();
      if (trimmed.charAt(0) === '{' || trimmed.charAt(0) === '[') {
        try {
          return { status: r.status, body: JSON.parse(trimmed) };
        } catch (_) { /* suite */ }
      }
      if (r.status === 404 || trimmed.indexOf('<') === 0) {
        return { status: r.status, body: { ok: false, error: 'proxy_not_configured' } };
      }
      return { status: r.status, body: { ok: false, error: 'network' } };
    });
  }

  var imLookupSeq = 0;
  var imLookupAbort = null;

  function lookupFetchOpts(signal, viaProxy) {
    var opts = {
      headers: { accept: 'application/json' },
      cache: 'no-store',
      signal: signal
    };
    if (viaProxy) opts.credentials = 'same-origin';
    return opts;
  }

  function withCacheBust(qs) {
    return qs + (qs.indexOf('?') >= 0 ? '&' : '?') + '_=' + Date.now();
  }

  function fetchLookup(section, qs) {
    if (imLookupAbort) {
      try { imLookupAbort.abort(); } catch (_) { /* ignore */ }
    }
    imLookupAbort = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var signal = imLookupAbort ? imLookupAbort.signal : undefined;
    var bustQs = withCacheBust(qs);
    var proxyPath = section.getAttribute('data-proxy-path') || '/apps/suivi/lookup';
    var directApiUrl = section.getAttribute('data-direct-api-url')
      || 'https://ironmeals-suivi.mos73086.workers.dev/lookup';

    function fetchDirect() {
      return fetch(directApiUrl + bustQs, Object.assign({ mode: 'cors' }, lookupFetchOpts(signal, false)))
        .then(parseLookupResponse);
    }
    function fetchProxy() {
      return fetch(proxyPath + bustQs, lookupFetchOpts(signal, true))
        .then(parseLookupResponse);
    }

    return fetchDirect()
      .then(function (res) {
        if (res.body && res.body.error === 'proxy_not_configured') return fetchProxy();
        return res;
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') throw err;
        return fetchProxy();
      });
  }

  /* ----------------------------- Modal rappels ----------------------------- */

  function imGetModal(section) {
    return section ? section.querySelector('[data-im-modal]') : null;
  }

  function imShowModal(modal) {
    if (!modal) return;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('im-modal-open');
  }

  function imCloseModal(section) {
    var modal = imGetModal(section);
    if (!modal) return;
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('im-modal-open');
  }

  function imOpenModalLoading(section) {
    var modal = imGetModal(section);
    if (!modal) return;
    var body = modal.querySelector('[data-im-modal-body]');
    var footer = modal.querySelector('[data-im-modal-footer]');
    if (body) {
      body.innerHTML =
        '<div class="im-modal__loading">' +
          '<span class="im-modal__spinner" aria-hidden="true"></span>' +
          '<p class="im-modal__loading-text">Récupération de votre suivi en cours…</p>' +
        '</div>' +
        '<p class="im-modal__intro">En attendant, quelques rappels :</p>' +
        '<div class="im-delivery-info">' + deliveryInfoCardsHtml(null, null) + '</div>';
    }
    if (footer) footer.innerHTML = '';
    imShowModal(modal);
  }

  function imUpdateModalOrder(section, order) {
    var modal = imGetModal(section);
    if (!modal || modal.hidden) return;
    var body = modal.querySelector('[data-im-modal-body]');
    var footer = modal.querySelector('[data-im-modal-footer]');
    var ful = (order.fulfillments || [])[0];
    var hasTracking = !!(ful && (ful.trackingUrl || ful.trackingNumber));
    if (body) {
      body.innerHTML = '<p class="im-modal__intro">Rappels pour votre livraison</p>' +
        renderDeliveryInfo(order, hasTracking);
    }
    if (footer) {
      footer.innerHTML = '<button type="button" class="im-btn im-btn--primary" data-im-modal-close>Voir mon suivi</button>';
    }
  }

  function runLookup(section, qs, onDone) {
    var reqId = ++imLookupSeq;
    var result = section.querySelector('[data-im-result]');
    return fetchLookup(section, qs)
      .then(function (res) {
        if (reqId !== imLookupSeq) return;
        if (!result) return;
        if (res.body && res.body.ok && res.body.order) {
          result.innerHTML = renderOrder(res.body.order);
          imUpdateModalOrder(section, res.body.order);
        } else {
          result.innerHTML = renderError((res.body && res.body.error) || 'unknown');
          imCloseModal(section);
        }
      })
      .catch(function (err) {
        if (reqId !== imLookupSeq) return;
        if (err && err.name === 'AbortError') return;
        if (result) result.innerHTML = renderError('network');
        imCloseModal(section);
      })
      .then(function () {
        if (reqId === imLookupSeq && onDone) onDone();
      });
  }

  function runAutoLookup(el) {
    var section = el.closest('.im-suivi');
    if (!section) return;
    var order = (el.getAttribute('data-order') || '').trim();
    var email = (el.getAttribute('data-email') || '').trim().toLowerCase();
    var phone = (el.getAttribute('data-phone') || '').trim();
    if (!order || !email) return;
    var qs = '?order=' + encodeURIComponent(order) + '&email=' + encodeURIComponent(email);
    if (phone) qs += '&phone=' + encodeURIComponent(phone);

    return fetchLookup(section, qs)
      .then(function (res) {
        el.removeAttribute('aria-busy');
        if (res.body && res.body.ok && res.body.order) {
          el.innerHTML = renderTrackingBlock(res.body.order);
          var orderLi = el.closest('.im-suivi__order');
          if (orderLi) {
            var prep = orderLi.querySelector('.im-preparing');
            if (prep) prep.remove();
          }
        } else {
          el.innerHTML = '<div class="im-suivi__lookup-fallback">' + renderError((res.body && res.body.error) || 'unknown') + '</div>';
        }
      })
      .catch(function () {
        el.removeAttribute('aria-busy');
        el.innerHTML = '<p class="im-suivi__lookup-fallback">Impossible de charger le suivi. Vérifiez votre connexion et réessayez.</p>';
      });
  }

  function initAutoLookups() {
    document.querySelectorAll('[data-im-auto-lookup]').forEach(function (el) {
      if (el.getAttribute('data-im-lookup-started')) return;
      el.setAttribute('data-im-lookup-started', '1');
      runAutoLookup(el);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAutoLookups);
  } else {
    initAutoLookups();
  }

  document.querySelectorAll('.im-suivi__mode-tab').forEach(function (tab) {
    tab.addEventListener('click', function () {
      var section = tab.closest('.im-suivi');
      var form = section && section.querySelector('[data-im-lookup-form]');
      if (!form) return;
      var mode = tab.getAttribute('data-im-mode') || 'phone';
      section.querySelectorAll('.im-suivi__mode-tab').forEach(function (t) {
        var on = t === tab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      form.setAttribute('data-im-mode', mode);
      var phoneField = form.querySelector('[data-im-field="phone"]');
      var orderField = form.querySelector('[data-im-field="order"]');
      var phoneIn = form.querySelector('input[name="phone"]');
      var orderIn = form.querySelector('input[name="order"]');
      if (mode === 'phone') {
        if (phoneField) phoneField.hidden = false;
        if (orderField) orderField.hidden = true;
        if (phoneIn) phoneIn.required = true;
        if (orderIn) { orderIn.required = false; orderIn.value = ''; }
      } else {
        if (phoneField) phoneField.hidden = true;
        if (orderField) orderField.hidden = false;
        if (phoneIn) { phoneIn.required = false; phoneIn.value = ''; }
        if (orderIn) orderIn.required = true;
      }
    });
  });

  document.querySelectorAll('[data-im-lookup-form]').forEach(function (form) {
    var section = form.closest('.im-suivi');
    var result = section && section.querySelector('[data-im-result]');
    var submit = form.querySelector('[data-im-submit]');
    var labelEl = form.querySelector('[data-im-label]');
    var spinnerEl = form.querySelector('[data-im-spinner]');
    var originalLabel = labelEl ? labelEl.textContent : 'Suivre ma commande';

    function setLoading(loading) {
      if (!submit) return;
      submit.disabled = loading;
      if (labelEl) labelEl.textContent = loading ? 'Suivi en cours…' : originalLabel;
      if (spinnerEl) spinnerEl.hidden = !loading;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var mode = form.getAttribute('data-im-mode') || 'phone';
      var emailInput = form.querySelector('input[name="email"]');
      var phoneInput = form.querySelector('input[name="phone"]');
      var orderInput = form.querySelector('input[name="order"]');
      var email = (emailInput.value || '').trim().toLowerCase();
      var qs = '';

      emailInput.setAttribute('aria-invalid', email ? 'false' : 'true');
      if (!email) return;

      if (mode === 'phone') {
        var phone = (phoneInput.value || '').trim();
        phoneInput.setAttribute('aria-invalid', phone ? 'false' : 'true');
        if (!phone) return;
        qs = '?phone=' + encodeURIComponent(phone) + '&email=' + encodeURIComponent(email);
      } else {
        var order = (orderInput.value || '').trim();
        orderInput.setAttribute('aria-invalid', order ? 'false' : 'true');
        if (!order) return;
        qs = '?order=' + encodeURIComponent(order) + '&email=' + encodeURIComponent(email);
      }

      setLoading(true);
      if (result) {
        result.hidden = false;
        result.innerHTML = '<div class="im-suivi__result-card">Recherche en cours…</div>';
      }
      imOpenModalLoading(section);
      runLookup(section, qs, function () { setLoading(false); });
    });
  });

  // Ouverture / fermeture du modal rappels (délégué).
  document.addEventListener('click', function (e) {
    var closeEl = e.target.closest && e.target.closest('[data-im-modal-close]');
    if (closeEl) {
      imCloseModal(closeEl.closest('.im-suivi'));
      return;
    }
    var openEl = e.target.closest && e.target.closest('[data-im-open-reminders]');
    if (openEl) {
      var section = openEl.closest('.im-suivi');
      imShowModal(imGetModal(section));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-im-modal]').forEach(function (modal) {
      if (!modal.hidden) imCloseModal(modal.closest('.im-suivi'));
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
